import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';

export default function ArticlePreview() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            Latest Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            Vigorbuy Spreadsheet Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Expert guides to help you make the most of your product research journey
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {articlePreviews.map((article, index) => (
            <article key={index} className="bg-background-100 rounded-lg border border-background-200 overflow-hidden group hover:border-primary-200 transition-all duration-300">
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-500 font-medium">{article.tag}</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mt-1 mb-1.5 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {article.summary}
                </p>
                <Link
                  to={`/article/${article.slug}`}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
                  className="inline-flex items-center gap-1 text-xs font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}